import axios from 'axios';
import { createAsyncThunk } from '@reduxjs/toolkit';
import authHeader from '../authHeader';

const base_url =window.location.origin+"/";

export const getTimeZone = createAsyncThunk(
    'get-time-zone',
    async  ()=>{
        try{
            const {data} = await axios.get(
                `${base_url}api/api/Configuration/GetTimeZoneDetails`,
               { headers:authHeader()}
            );
            return data;
        }catch(error){
            if(error.response && error.response.data){
                return error.response.data;
            }else{
                return error.response.data;
            }
        }
    }
);

export const getCurrency = createAsyncThunk(
    'get-currency',
    async  ()=>{
        try{
            const {data} = await axios.get(
                `${base_url}api/api/Configuration/GetCurrencyDetails`,
                
               { headers:authHeader()}
            );
            return data;
        }catch(error){
            if(error.response && error.response.data){
                return error.response.data
            }else{
                return error.response.data
            }
        }
    }
);

export const getCountry = createAsyncThunk(
    'get-country',
    async (id) => {
        try{
            const {data} = await axios.get(
                `${base_url}api/api/Configuration/GetCountryList/${id}`,
                {headers: authHeader()}
            );
            return data;
        }
        catch(error){
            if(error.response && error.response.data){
                // return rejectWithValue(error.response.data)
            }else{
                // return rejectWithValue(error.response.data)
            }
        }
    }
);

export const getGenralSetting = createAsyncThunk(
    'get-general-setting',
    async (payload,{rejectWithValue})=>{
        try{
            const {data} = await axios.post(
                `${base_url}api/api/Configuration/GetGeneralConfigSettings`,
                payload,
               { headers:authHeader()}
            );
            return data;
        }catch(error){
            if(error.response && error.response.data){
                return rejectWithValue(error.response.data)
            }else{
                return rejectWithValue(error.response.data)
            }
        }
    }
);

export const saveGenralSetting = createAsyncThunk(
    'save-general-setting',
    async (payload,{rejectWithValue})=>{
        try{
            const {data} = await axios.post(
                `${base_url}api/api/Configuration/SaveGeneralConfigSettings`,
                payload,
               { headers:authHeader()}
            );
            return data;
        }catch(error){
            if(error.response && error.response.data){
                return rejectWithValue(error.response.data)
            }else{
                return rejectWithValue(error.response.data)
            }
        }
    }
);